import { render, staticRenderFns } from "./DeleteFakeTeam.vue?vue&type=template&id=88b51bc0&scoped=true"
import script from "./DeleteFakeTeam.vue?vue&type=script&lang=js"
export * from "./DeleteFakeTeam.vue?vue&type=script&lang=js"
import style0 from "./DeleteFakeTeam.vue?vue&type=style&index=0&id=88b51bc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b51bc0",
  null
  
)

export default component.exports